import React, {Component} from 'react';
import PropTypes from 'prop-types';
import GenericModal from '../../../containers/modal/generic_modal';
import {injectIntl} from 'react-intl';
import {BUTTON_COLOR} from '../../../constants';
import Checkbox from '../../../components/new-ui/check_box';
import {duplicateProject} from '../scheduling_mutations';
import Input from '../../../components/new-ui/input_field';
import DateRangePicker from '../../../components/new-ui/date-controls/date_range_picker';
import Util from '../../../forecast-app/shared/util/util';

class DuplicateProjectModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			duplicateSettings: true,
			duplicateTasks: true,
			duplicatePhases: true,
			duplicateTeam: true,
			duplicateAllocations: true,
			duplicatePlaceholders: true,
			duplicateExpenses: true,
			duplicateRetainerPeriods: true,
			name: '',
			startDate: null,
			endDate: null,
		};
	}

	handleSettingsChange() {
		this.setState({duplicateSettings: !this.state.duplicateSettings});
	}

	handleTasksChange() {
		this.setState({duplicateTasks: !this.state.duplicateTasks});
	}

	handlePhasesChange() {
		this.setState({duplicatePhases: !this.state.duplicatePhases});
	}

	handleTeamChange() {
		this.setState({duplicateTeam: !this.state.duplicateTeam});
	}

	handleAllocationsChange() {
		this.setState({duplicateAllocations: !this.state.duplicateAllocations});
	}

	handlePlaceholders() {
		this.setState({duplicatePlaceholders: !this.state.duplicatePlaceholders});
	}

	handleExpensesChange() {
		this.setState({duplicateExpenses: !this.state.duplicateExpenses});
	}

	handleRetainerPeriodsChange() {
		this.setState({duplicateRetainerPeriods: !this.state.duplicateRetainerPeriods});
	}

	handleDateRangeChange(startDate, endDate) {
		this.setState({startDate, endDate});
	}

	handleNameChange(name) {
		this.setState({name});
	}

	duplicateProject() {
		const {
			duplicateSettings,
			duplicateTasks,
			duplicatePhases,
			duplicateTeam,
			duplicateAllocations,
			duplicateExpenses,
			duplicateRetainerPeriods,
			duplicatePlaceholders,
			name,
			startDate,
			endDate,
		} = this.state;

		const onSuccess = result => {
			Util.dispatchScheduleEvent(result);
			if (this.props.onSuccess) {
				this.props.onSuccess(result);
			}
		};

		duplicateProject(
			{
				projectId: this.props.projectId,
				duplicateSettings: duplicateSettings,
				duplicateTasks: duplicateTasks,
				duplicatePhases: duplicatePhases,
				duplicateExpenses: duplicateExpenses,
				duplicateRetainerPeriods: duplicateRetainerPeriods,
				duplicateProjectPersons: duplicateTeam,
				duplicateAllocations: duplicateAllocations,
				duplicatePlaceholders,
				projectStartYear: startDate ? startDate.year() : null,
				projectStartMonth: startDate ? startDate.month() + 1 : null,
				projectStartDay: startDate ? startDate.date() : null,
				projectEndYear: endDate ? endDate.year() : null,
				projectEndMonth: endDate ? endDate.month() + 1 : null,
				projectEndDay: endDate ? endDate.date() : null,
				name,
			},
			onSuccess
		);
	}

	render() {
		const {formatMessage} = this.props.intl;
		const {
			duplicateSettings,
			duplicateTasks,
			duplicatePhases,
			duplicateTeam,
			duplicateAllocations,
			duplicateExpenses,
			duplicateRetainerPeriods,
			duplicatePlaceholders,
			startDate,
			endDate,
			name,
		} = this.state;

		const content = (
			<div className="project-group-duplicate-modal">
				<Input
					placeholder={formatMessage({id: 'common.project-name'})}
					type="text"
					label={formatMessage({id: 'common.project'})}
					value={name}
					onChange={this.handleNameChange.bind(this)}
				/>
				<DateRangePicker
					startDate={startDate}
					endDate={endDate}
					handleDateRangeChange={this.handleDateRangeChange.bind(this)}
				/>
				<div className="option-row">
					<div className="option-text">{formatMessage({id: 'duplicate-modal.settings'})}</div>
					<Checkbox isChecked={duplicateSettings} onChange={this.handleSettingsChange.bind(this)} />
				</div>
				<div className="option-row">
					<div className="option-text">{formatMessage({id: 'duplicate-modal.cards'})}</div>
					<Checkbox isChecked={duplicateTasks} onChange={this.handleTasksChange.bind(this)} />
				</div>
				<div className="option-row">
					<div className="option-text">{formatMessage({id: 'duplicate-modal.scopes'})}</div>
					<Checkbox isChecked={duplicatePhases} onChange={this.handlePhasesChange.bind(this)} />
				</div>
				<div className="option-row">
					<div className="option-text">{formatMessage({id: 'duplicate-modal.team'})}</div>
					<Checkbox isChecked={duplicateTeam} onChange={this.handleTeamChange.bind(this)} />
				</div>
				{duplicateTeam && this.props.isUsingProjectAllocation && (
					<div className="option-row">
						<div className="option-text">{formatMessage({id: 'duplicate-modal.allocations'})}</div>
						<Checkbox isChecked={duplicateAllocations} onChange={this.handleAllocationsChange.bind(this)} />
					</div>
				)}
				<div className="option-row">
					<div className="option-text">{formatMessage({id: 'project_budget.expenses'})}</div>
					<Checkbox isChecked={duplicateExpenses} onChange={this.handleExpensesChange.bind(this)} />
				</div>
				<div className="option-row">
					<div className="option-text">{formatMessage({id: 'duplicate-modal.retainer_periods'})}</div>
					<Checkbox isChecked={duplicateRetainerPeriods} onChange={this.handleRetainerPeriodsChange.bind(this)} />
				</div>
				<div className="option-row">
					<div className="option-text">{formatMessage({id: 'duplicate-modal.placeholders'})}</div>
					<Checkbox isChecked={duplicatePlaceholders} onChange={this.handlePlaceholders.bind(this)} />
				</div>
			</div>
		);

		return (
			<GenericModal
				headerText={formatMessage({id: 'project_settings.duplicate-project'})}
				closeModal={this.props.closeModal}
				buttons={[
					{text: formatMessage({id: 'common.cancel'}), color: BUTTON_COLOR.WHITE},
					{
						text: formatMessage({id: 'common.duplicate'}),
						disabled: !name.trim(),
						callback: this.duplicateProject.bind(this),
					},
				]}
				content={content}
			/>
		);
	}
}

DuplicateProjectModal.propTypes = {
	projectId: PropTypes.string.isRequired,
	onSuccess: PropTypes.func,
};

export default injectIntl(DuplicateProjectModal);
